module.exports = __webpack_public_path__ + "img/d202110_1.23326390.jpg";